<template>
  <div class="coming-soon d-flex flex-column justify-content-center align-items-center text-center rounded-lg">
    <div class="content p-4 rounded-4 shadow-lg bg-white bg-opacity-75">
      <img
        src="@/assets/images/bollide/pictures/coming-soon.png"
        alt="Cute Coming Soon Illustration"
        class="illustration mb-4" 
      />
      <h1 class="fw-bold text-primary mb-3">Something Adorable is Coming Soon!</h1>
      <p class="lead text-secondary mb-4">
        We’re working hard to bring you something special. Stay tuned!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComingSoon",
};
</script>

<style scoped>
.coming-soon {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.illustration {
  width: 150px;
  height: auto;

}

.time-box {
  background: #fff;
  border-radius: 19px;
  padding: 10px 15px;
  min-width: 70px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.time-number {
  font-size: 1.5rem;
  font-weight: 700;
  display: block;
  color: #ff69b4;
}

.time-label {
  font-size: 0.8rem;
  color: #555;
}
</style>
